import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { PageResourceFetcher } from './PageResourceFetcher'
import { PageStyleLoaderSymbol, PageResourceFetcherWithWarmupDataSymbol } from './symbols'
import { PageAssetsLoaderImpl } from './PageAssetsLoader'
import { ILoadPageStyle, ClientPageStyleLoader, ServerPageStyleLoader, PageMainCssFetcher } from './PageStyleLoader'
import {
	IPageAssetsLoader,
	PageAssetsLoaderSymbol,
	ICssFetcher,
	CssFetcherSymbol,
	PageResourceFetcherSymbol,
	IPageResourceFetcher,
} from '@wix/thunderbolt-symbols'
import { PageResourceFetcherWithWarmupData } from './PageResourceFetcherWithWarmupData'
import { WarmupDataEnricherSymbol } from 'feature-warmup-data'
import { SiteAssetsWarmupDataEnricher } from './SiteAssetsWarmupDataEnricher'

export const site: ContainerModuleLoader = (bind) => {
	bind<IPageResourceFetcher>(PageResourceFetcherSymbol).to(PageResourceFetcher)
	bind<IPageResourceFetcher>(PageResourceFetcherWithWarmupDataSymbol).to(PageResourceFetcherWithWarmupData)
	bind<IPageAssetsLoader>(PageAssetsLoaderSymbol).to(PageAssetsLoaderImpl)
	bind<ICssFetcher>(CssFetcherSymbol).to(PageMainCssFetcher)
	if (process.env.browser) {
		bind<ILoadPageStyle>(PageStyleLoaderSymbol).to(ClientPageStyleLoader)
	} else {
		bind(WarmupDataEnricherSymbol).to(SiteAssetsWarmupDataEnricher)
		bind<ILoadPageStyle>(PageStyleLoaderSymbol).to(ServerPageStyleLoader)
	}
}
